var container;
function getContainer() {
    if (typeof window === 'undefined') {
        return null;
    }
    if (container) {
        return container;
    }
    container = document.createElement('div');
    container.style.display = 'inline-flex';
    container.style.position = 'absolute';
    container.style.top = '-9999px';
    container.style.left = '-9999px';
    container.style.flexDirection = 'row';
    container.style.justifyContent = 'flex-start';
    container.style.visibility = 'hidden';
    document.body.appendChild(container);
    return container;
}
var defaultResult = {
    originalWidth: 0,
    fullWidth: 0
};
export function measureText(ref) {
    if (!ref.current) {
        return defaultResult;
    }
    var container = getContainer();
    if (!container) {
        return defaultResult;
    }
    container.innerHTML = '';
    var clone = ref.current.cloneNode(true);
    clone.removeAttribute('data-selector-id');
    container.appendChild(clone);
    return {
        originalWidth: ref.current.getBoundingClientRect().width,
        fullWidth: container.getBoundingClientRect().width
    };
}
//# sourceMappingURL=measureText.js.map